export default __webpack_public_path__ + "static/media/upload-document.f980d6dc.svg";